import { SeverityLevel } from '@microsoft/applicationinsights-web';
import axios, { AxiosRequestConfig } from 'axios';

import telemetryProvider from '../telemetry';
import { getOrganizationAppOriginFromEnv } from './EnvironmentUtil';

export async function getSignInCMSData() {
    try {
        const config: AxiosRequestConfig = {
            method: 'get',
            url: `${getOrganizationAppOriginFromEnv()}/portal_/api/content/billboard/getSignInCMSData`,
        };
        const response = await axios(config);
        return response.data;
    } catch (error) {
        telemetryProvider.trackTrace({
            message: `Error occured while retrieving billboard cms data: ${error}`,
            severityLevel: SeverityLevel.Error,
        });
    }
}
